export const SUCCESS_HEADER_TITLE = 'Email verified!';
export const SUCCESS_HEADER_SUBTITLE = 'Thanks for verifying!';
export const SUCCESS_BODY_MESSAGE = "We have verified your account, and you're all set to start using the Branch Dashboard.";
export const SUCCESS_BUTTON_TITLE = 'Continue to sign in';
export const SUCCESS_IMAGE_URL = '/static/images/loggedout/img_verified.png';
export const FAILURE_HEADER_TITLE = 'Email verification failed';
export const FAILURE_HEADER_SUBTITLE = 'Something went wrong';
export const FAILURE_BODY_MESSAGE = 'We were unable to verify your account. Please try again later!';
export const FAILURE_BUTTON_TITLE = 'Signup';
export const FAILURE_IMAGE_URL = '/static/images/loggedout/img_linkExpired.png';
export const EMAIL_VERIFICATION_IN_PROGRESS = 'EMAIL_VERIFICATION_IN_PROGRESS';
export const EMAIL_VERIFICATION_SUCCESSFUL = 'EMAIL_VERIFICATION_SUCCESSFUL';
